import React from 'react';

function Stomes() {
  return (
    <div>
      <h2>Stomes Care</h2>
      <p>We provide expert care for stomes to improve quality of life...</p>
    </div>
  );
}

export default Stomes;
